module.exports = "/_next/static/images/d1fdc67ef20d1bb3427b05845dfe0070-mother-and-daugther@1x.jpg";